import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: 'General Staffing & Recruitment', path: '/general-staffing' },
      { label: 'IT Hiring', path: '/krishpar-hiring' },
      { label: 'IT Staffing', path: '/it-staffing-contracts' },
      { label: 'IT Staff Augmentation', path: '/krishpar-staff-augmentation' },
      { label: 'IT Services', path: '/it-services' },
      { label: 'Workforce Solutions', path: '/workforce' },
      { label: 'Payroll Services', path: '/payroll-services' },
      { label: 'HR Compliance & Advisory', path: '/hr-compliance-advisory' },
      // { label: 'Emploi', path: '/emploi-product' },
      // { label: 'Payroll', path: '/krishpar-payroll' }
    ],
    company: [
      { label: 'About Us', path: '/about' },
      { label: 'Careers', path: '/career' },
      { label: 'Contact Us', path: '/contact' },
    ],
    products: [
      { label: 'Emploi Platform', path: '/emploi-product' },
      { label: 'PeopleX HR Platform', path: '/payroll-product' },
    ],
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <img src="/Logo.png" alt="Krishpar Technologies" className="logo-image" />
            </Link>
            <p>
              Delivering excellence in IT staffing, recruitment, and payroll solutions since 2018. 
              Your trusted partner for workforce solutions transformation.
            </p>
          </div>

          <div className="footer-col">
            <h4>HR Services</h4>
            {footerLinks.services.map((link) => (
              <Link key={link.path} to={link.path}>
                {link.label}
              </Link>
            ))}
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            {footerLinks.company.map((link) => (
              <Link key={link.path} to={link.path}>
                {link.label}
              </Link>
            ))}
          </div>

          <div className="footer-col">
            <h4>Products</h4>
            {footerLinks.products.map((link) => (
              <Link key={link.path} to={link.path}>
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Krishpar Technologies. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms and Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
